import { render } from "./contactBannerComponent.vue?vue&type=template&id=39fc3928"
import script from "./contactBannerComponent.vue?vue&type=script&lang=js"
export * from "./contactBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__